import * as types from '../constants/actionTypes';
import { MEMBER_SEARCH_SCREEN } from '../constants/category';
import { PAGING_DEFAULT, STATUS_RESULT_TYPE } from '../constants/constants';
import memberProfileService from '../services/memberProfileService';
import memberSearchService from '../services/memberSearchService';
import * as myStore from '../store/myStore';
import { updateCommonStateReducerSuccess, updateDataSpotlightModalSuccess, updateMessageNotificationError } from './commonStateAction';
// import I18n from "react-native-i18n"
import { mergeDataHome } from 'redhotpie-shared-lib/actions/newFeedAction';
import TYPE from 'redhotpie-shared-lib/constants/newFeed';
import { messageUtils } from '../functions';
import dateFinderService from '../services/dateFinderService';
import { getUserProfilePhotoSuccess } from './editProfileActions';
import { updateUserStatusActionSuccess } from './memberSearchActions';
import { getMyTravelPlan } from './travelPlanActions';
import * as userActions from './userActions';
import { IMemberProfile } from 'redhotpie-shared-lib/interfaces/IUser';
import { IApiResponse } from 'redhotpie-shared-lib/interfaces/IApiResponse';

export function updateListUsersLikedSuccess(userId: number) {
  return { type: types.UPDATE_LIST_USERS_LIKED_SUCCESS, userId };
}

export function getMemberProfileSuccess(userId: number, data: any) {
  return { type: types.GET_MEMBER_PROFILE_SUCCESS, userId, data };
}

export function getMemberProfileTimeout(userId: number, data: any) {
  return { type: types.GET_MEMBER_PROFILE_TIME_OUT, userId, data };
}

export function getMemberProfileValidateSuccess(userId: number, params: any, data: any, total: number, isPrivateValidations?: boolean) {
  return {
    type: types.GET_MEMBER_PROFILE_VALIDATE_SUCCESS,
    userId,
    params,
    data,
    total,
    isPrivateValidations,
  };
}

export function getMemberProfileEntitiesSuccess(userId: number, entityData: any) {
  return {
    type: types.GET_MEMBER_PROFILE_ENTITIES_SUCCESS,
    userId,
    entityData,
  };
}

export function getMemberProfileFriendsSuccess(userId: number, params: any, data: any, total: number) {
  return {
    type: types.GET_MEMBER_PROFILE_FRIENDS_SUCCESS,
    userId,
    params,
    data,
    total,
  };
}

export function updateMemberProfileState(data: any) {
  return { type: types.UPDATE_MEMBER_PROFILE_STATE, data };
}

export function updateMemberProfilePropertyState(data: any) {
  return { type: types.UPDATE_MEMBER_PROFILE_PROPERTY_STATE, data };
}

export function updateUserViewingIdSuccess(userId: number | null) {
  return { type: types.UPDATE_VIEWING_USER_ID, userId };
}

export function updateUserViewingId(userId: number | null) {
  return (dispatch: any) => {
    dispatch(updateUserViewingIdSuccess(userId));
  };
}
export function getProfileActivitySuccess(data: any, userId: number) {
  return { type: types.GET_PROFILE_ACTIVITY_SUCCESS, data, userId };
}

export function getProfileGroupsSuccess(data: any, userId: number, size: number, page: number) {
  return { type: types.GET_PROFILE_GROUPS_SUCCESS, data, userId, size, page };
}

export function postUserMemberProfileActionSuccess(
  user: any,
  index: number,
  actionType: string,
  params: any,
  actionSuccess: any,
  isLikedMutualMatch: boolean,
  isFavouritedMutualMatch: boolean
) {
  return {
    type: types.POST_USERS_MEMBER_PROFILE_ACTION_SUCCESS,
    user,
    index,
    actionType,
    params,
    actionSuccess,
    isLikedMutualMatch,
    isFavouritedMutualMatch,
  };
}

export function updateMemberProfileTravelPlanSuccess(userId: number, travelPlanId: number) {
  return { type: types.UPDATE_MEMBER_PROFILE_TRAVEL_PLAN_SUCCESS, userId, travelPlanId };
}

export function getMemberProfileAllData(userId: number) {
  return (dispatch: any) => {
    dispatch(getMemberProfile(userId));
    dispatch(getMemberProfilePhoto(userId));
    dispatch(getMemberProfileValidations(userId));
    dispatch(getMemberProfileValidateCount(userId));
    dispatch(getMemberProfileFriends(userId));
    dispatch(getMemberProfileFriendCount(userId));
    dispatch(getMemberProfileTravelPlans(userId));
    dispatch(getMemberProfileDateFinder(userId));
    dispatch(getMemberProfilePhotoAmateur(userId));
    dispatch(getProfileGallery(userId));
    dispatch(getProfileNote(userId));
  };
}

export function getProfileDetailAndPhotos(userId: number) {
  return (dispatch: any, getState: any) => {
    const { isLoadingPhotoAPI } = getState().memberProfileReducer;
    if (!isLoadingPhotoAPI) {
      dispatch(getMemberProfile(userId));
      dispatch(getMemberProfilePhoto(userId));
      dispatch(getProfileNote(userId));
      dispatch(getProfileGallery(userId));
      //dispatch(getProfileActivity(userId));
    }
  };
}

export function getAllTheRestProfile(userId: number, isDesktopView: boolean, isOwnProfile: boolean) {
  return (dispatch: any) => {
    dispatch(
      getMemberProfileValidations(userId, {
        pageNumber: 1,
        pageSize: PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
      })
    );
    dispatch(getMemberProfileFriends(userId, { pageNumber: 1, pageSize: PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH }));
    isOwnProfile ? dispatch(getMyTravelPlan({ userId })) : dispatch(getMemberProfileTravelPlans(userId));
    dispatch(getMemberProfileDateFinder(userId, isOwnProfile));
    dispatch(getUserProfileGroups(userId, { page: 1, size: 5 }));
    if (isDesktopView) {
      // dispatch(getMemberProfilePhotoAmateur(userId));
      // dispatch(getProfileGallery(userId));
    }
  };
}

export function getProfileDetail(userId: number) {
  return (dispatch: any) => {
    dispatch(getMemberProfile(userId));
    dispatch(getMemberProfilePhoto(userId));
    dispatch(getProfileNote(userId));
    // dispatch(getProfileActivity(userId));
  };
}

export function getMemberProfile(userId: number) {
  return (dispatch: any) => {
    if (userId && userId !== -1 && userId !== 0) {
      dispatch(updateMemberProfileState({ isLoading: true }));
      const numUserId = userId;
      return memberProfileService
        .getMemberProfile(numUserId || userId)
        .then(res => {
          const { loginReducer } = myStore.getStore().getState();
          let data = {
            ...res.data,
            isProfileNotFound: loginReducer?.userInfo?.userId === (numUserId || userId) ? false : res.isProfileNotFound,
          };
          if (!res.success && res.isRequestTimeout) {
            data = { detail: { isRequestTimeout: true }, isProfileNotFound: false };
          }
          dispatch(getMemberProfileSuccess(userId, data));
          return res;
        })
        .catch(e => {
          console.warn('ERROR: memberProfileActions/getMemberProfile', e);
        });
    }
    dispatch(getMemberProfileSuccess(-1, { isProfileNotFound: true }));
    return Promise.resolve({
      success: true,
    });
  };
}

export function getMemberProfilePhoto(userId: number, customHeader?: any, params?: any) {
  return (dispatch: any) => {
    if (userId && userId !== -1 && userId !== 0) {
      const entityData = { isLoadingPhotoAPI: true };
      if (params && params.ignoreLoading) {
        entityData.isLoadingPhotoAPI = false;
      }
      dispatch(getMemberProfileEntitiesSuccess(userId, entityData));
      return memberProfileService.getMemberPhotos(userId).then(res => {
        if (res.success) {
          dispatch(
            getMemberProfileEntitiesSuccess(userId, {
              photos: res.data,
              isLoadingPhotoAPI: false,
            })
          );
        } else if (res.isRequestTimeout) {
          dispatch(
            getMemberProfileEntitiesSuccess(userId, {
              photos: { isRequestTimeout: true, isLoadingPhotoAPI: false },
            })
          );
        } else {
          console.warn('ERROR: memberProfileActions/getMemberProfilePhoto', res.message);
        }
        return res;
      });
    }
    dispatch(getMemberProfileEntitiesSuccess(-1, { isLoadingPhotoAPI: false }));
    return Promise.resolve({ success: true });
  };
}

export function getMemberProfilePhotoAmateur(userId: number) {
  return (dispatch: any) => {
    return memberProfileService.getMemberPhotoAmateur(userId).then(res => {
      if (res.success) {
        dispatch(getMemberProfileEntitiesSuccess(userId, { photosAmateur: res.data }));
      } else {
        console.warn('ERROR: memberProfileActions/getMemberProfilePhotoAmateur', res.message);
      }
      return res;
    });
  };
}

export function getMemberProfileValidations(userId: number, params?: any) {
  return (dispatch: any) => {
    dispatch(updateMemberProfileState({ isLoading: true }));
    return memberProfileService.getMemberValidates(userId, params).then((res: IApiResponse) => {
      if (res.success) {
        dispatch(getMemberProfileValidateSuccess(userId, params, res.data, res.total || 0));
      } else {
        console.warn('ERROR: memberProfileActions/getMemberProfileValidations', res?.message || '');

        let isPrivateValidations = false;
        if (typeof res.data === 'object' && res.data !== null && 'ResponseStatus' in res.data) {
          isPrivateValidations = res.data?.ResponseStatus?.ErrorCode === '1004';
        }
        dispatch(getMemberProfileValidateSuccess(userId, params, [], 0, isPrivateValidations));
      }
      return res;
    });
  };
}

export function getMemberProfileFriends(userId: number, params?: any) {
  return (dispatch: any) => {
    dispatch(updateMemberProfileState({ isLoading: true }));
    return memberProfileService.getMemberFriends(userId, params).then(res => {
      if (res.success) {
        dispatch(getMemberProfileFriendsSuccess(userId, params, res.data, res.total || 0));
      } else {
        console.warn('ERROR: memberProfileActions/getMemberProfileFriends', res.message);
        dispatch(getMemberProfileFriendsSuccess(userId, params, [], 0));
      }
      return res;
    });
  };
}

export function getMemberProfileFriendCount(userId: number) {
  return (dispatch: any) => {
    return memberProfileService.getMemberFriendCount(userId).then(res => {
      if (res.success) {
        dispatch(getMemberProfileEntitiesSuccess(userId, { totalFriend: res.data }));
      } else {
        console.warn('ERROR: memberProfileActions/getMemberProfileFriendCount', res.message);
      }
      return res;
    });
  };
}

export function getMemberProfileValidateCount(userId: number) {
  return (dispatch: any) => {
    return memberProfileService.getMemberValidateCount(userId).then(res => {
      if (res.success) {
        dispatch(getMemberProfileEntitiesSuccess(userId, { totalValidate: res.data }));
      } else {
        console.warn('ERROR: memberProfileActions/getMemberProfileValidateCount', res.message);
      }
      return res;
    });
  };
}

export function getMemberProfileTravelPlans(userId: number) {
  return (dispatch: any) => {
    return memberProfileService.getMemberTravelPlans(userId).then(res => {
      if (res.success) {
        dispatch(getMemberProfileEntitiesSuccess(userId, { travelPlans: res.data }));
      } else {
        console.warn('ERROR: memberProfileActions/getMemberProfileTravelPlans', res.message);
      }
      return res;
    });
  };
}

export function getMemberProfileDateFinder(userId: number, isOwnProfile?: boolean) {
  return (dispatch: any) => {
    if (isOwnProfile) {
      return dateFinderService.getMyDateFinder().then(res => {
        if (res.success) {
          dispatch(getMemberProfileEntitiesSuccess(userId, { dateFinder: res.data }));
        } else {
          console.warn('ERROR: memberProfileActions/getMemberProfileDateFinder', res.message);
        }
        return res;
      });
    }
    return memberProfileService.getMemberDateFinder(userId).then(res => {
      if (res.success) {
        dispatch(getMemberProfileEntitiesSuccess(userId, { dateFinder: res.data }));
      } else {
        console.warn('ERROR: memberProfileActions/getMemberProfileDateFinder', res.message);
      }
      return res;
    });
  };
}

export function getProfileGallery(userId: number) {
  return (dispatch: any) => {
    if (userId && userId !== -1 && userId !== 0) {
      dispatch(getMemberProfileEntitiesSuccess(userId, { isLoadingGallery: true }));
      return memberProfileService.getProfileGallery(userId).then(res => {
        if (res.success) {
          dispatch(
            getMemberProfileEntitiesSuccess(userId, {
              photoGallery: res.data,
              isLoadingGallery: false,
            })
          );
        } else {
          console.warn('ERROR: memberProfileActions/getProfileGallery', res.message);
        }
        return res;
      });
    }
    dispatch(getMemberProfileEntitiesSuccess(-1, { isLoadingGallery: false }));
    return Promise.resolve({ success: true });
  };
}

export function postCreateValidation(userId: number, params: any) {
  return (dispatch: any, getState: any) => {
    const memberProfile = getState().memberProfileReducer[userId];
    dispatch(
      updateMemberProfileState({
        [userId]: { ...memberProfile, isSuccess: false, message: '' },
      })
    );
    return memberProfileService.postCreateValidation(userId, params).then(res => {
      if (res.success) {
        dispatch(
          updateMemberProfileState({
            [userId]: {
              ...memberProfile,
              profileIntersection: {
                ...memberProfile.profileIntersection,
                hasValidationRequest: res.success,
                canAddValidation: false,
              },
              isSuccess: res.success,
              message: res.message,
            },
            notificationModal: {
              isShow: true,
              message: res.message,
              messageKey: res.message ? null : 'MemberProfileScreen.ContentSuccessValidation',
            },
          })
        );
      } else {
        dispatch(updateMessageNotificationError(res.message));
      }
      return res;
    });
  };
}

export function patchUpdateValidation(userId: number, params: any) {
  return (dispatch: any, getState: any) => {
    const memberProfile = getState().memberProfileReducer[userId];
    dispatch(
      updateMemberProfileState({
        [userId]: { ...memberProfile, isSuccess: false, message: '' },
      })
    );
    return memberProfileService.patchUpdateValidation(userId, params).then(res => {
      if (res.success) {
        dispatch(
          updateMemberProfileState({
            [userId]: {
              ...memberProfile,
              profileIntersection: {
                ...memberProfile.profileIntersection,
                hasValidationRequest: res.success ? false : memberProfile.profileIntersection?.hasValidationRequest || false,
                canAddValidation: true,
              },
              isSuccess: res.success,
              message: res.message,
            },
            notificationModal: {
              isShow: !!res.message,
              message: res.message ? res.message : null,
            },
          })
        );
      } else {
        dispatch(updateMessageNotificationError('Error occurred while processing the request'));
      }
      return res;
    });
  };
}

export function postCreateFriend(userId: number, params: any) {
  return (dispatch: any, getState: any) => {
    const memberProfile = getState().memberProfileReducer[userId];
    if (memberProfile) {
      dispatch(
        updateMemberProfileState({
          [userId]: { ...memberProfile, isSuccess: false, message: '' },
        })
      );
    }
    return memberProfileService.postCreateFriend(userId, params).then(res => {
      if (res.success) {
        if (memberProfile) {
          let updateData = {
            [userId]: {
              ...memberProfile,
              profileIntersection: {
                ...memberProfile.profileIntersection,
                hasFriendRequest: res.success,
              },
              isSuccess: res.success,
              message: res.message,
            },
            notificationModal: {
              isShow: !!res.message,
              message: res.message ? res.message : null,
            },
            isShowViewAllFriends: false,
          };
          if (memberProfile.isShowViewAllFriends) {
            updateData = {
              ...updateData,
              isShowViewAllFriends: !memberProfile.isShowViewAllFriends,
            };
          }
          dispatch(updateMemberProfileState({ ...updateData }));
        }

        const {
          commonStateReducer: { dataSpotlightModal },
        } = myStore.getStore().getState();
        if (dataSpotlightModal.length > 0) {
          const splUser = dataSpotlightModal.find((itm: any) => itm.detail.userId === userId);
          let { profileIntersection = {} } = splUser;
          profileIntersection = {
            ...profileIntersection,
            hasFriendRequest: res.success,
          };
          dispatch(updateDataSpotlightModalSuccess(userId.toString(), { profileIntersection }));
        }
      } else {
        dispatch(updateMessageNotificationError(res.message));
      }
      return res;
    });
  };
}

export function patchUpdateFriend(userId: number, params: any) {
  return (dispatch: any, getState: any) => {
    const memberProfile = getState().memberProfileReducer[userId];
    if (memberProfile) {
      dispatch(
        updateMemberProfileState({
          [userId]: { ...memberProfile, isSuccess: false, message: '' },
        })
      );
    }
    return memberProfileService.patchUpdateFriend(params).then(res => {
      if (res.success) {
        if (memberProfile) {
          let updateData = {
            [userId]: {
              ...memberProfile,
              profileIntersection: {
                ...memberProfile.profileIntersection,
                isFriend: res.success ? false : memberProfile.profileIntersection?.isFriend,
                hasFriendRequest: res.success ? false : memberProfile.profileIntersection?.hasFriendRequest,
                hasFriendRequestDeleted: true,
              },
              isSuccess: res.success,
              message: res.message,
            },
            notificationModal: {
              isShow: !!res.message,
              message: res.message ? res.message : null,
            },
            isShowViewAllFriends: false,
          };
          if (memberProfile.isShowViewAllFriends) {
            updateData = {
              ...updateData,
              isShowViewAllFriends: !memberProfile.isShowViewAllFriends,
            };
          }
          dispatch(updateMemberProfileState({ ...updateData }));
        }
        const {
          commonStateReducer: { dataSpotlightModal },
        } = myStore.getStore().getState();
        if (dataSpotlightModal.length > 0) {
          const splUser = dataSpotlightModal.find((itm: any) => itm.detail.userId === userId);
          let { profileIntersection = {} } = splUser;
          profileIntersection = {
            ...profileIntersection,
            isFriend: res.success ? false : profileIntersection?.isFriend || false,
            hasFriendRequest: res.success ? false : profileIntersection?.hasFriendRequest || false,
            hasFriendRequestDeleted: true,
          };
          dispatch(updateDataSpotlightModalSuccess(userId.toString(), { profileIntersection }));
        }
      } else {
        dispatch(updateMessageNotificationError('Error occurred while processing the request'));
      }
      return res;
    });
  };
}

export function postCreateDateFinderInterest(userId: number, dateFinderId: number, indexDateFinder: number) {
  return (dispatch: any, getState: any) => {
    return memberProfileService.postCreateDateFinderInterest(dateFinderId).then(res => {
      if (res.success) {
        const { dateFinder } = getState().memberProfileReducer[userId];
        dispatch(
          updateMemberProfilePropertyState({
            dataKey: [userId.toString(), 'dateFinder', indexDateFinder],
            dataValue: {
              ...dateFinder[indexDateFinder],
              hasExpressedInterest: res.data,
            },
          })
        );
      } else {
        console.warn('ERROR: memberProfileActions/postCreateDateFinderInterest', res.message);
      }
      return res;
    });
  };
}

export function postCreateDateFinderUnInterest(userId: number, dateFinderId: number, indexDateFinder: number) {
  return (dispatch: any, getState: any) => {
    return memberProfileService.postCreateDateFinderUnInterest(dateFinderId).then(res => {
      if (res.success) {
        const { dateFinder } = getState().memberProfileReducer[userId];
        dispatch(
          updateMemberProfilePropertyState({
            dataKey: [userId.toString(), 'dateFinder', indexDateFinder],
            dataValue: {
              ...dateFinder[indexDateFinder],
              hasExpressedInterest: !res.data,
            },
          })
        );
      } else {
        console.warn('ERROR: memberProfileActions/postCreateDateFinderUnInterest', res.message);
      }
      return res;
    });
  };
}

export function getProfileNote(userId: number) {
  return (dispatch: any) => {
    if (userId && userId !== -1 && userId !== 0) {
      return memberProfileService.getProfileNote(userId).then(res => {
        if (res.success) {
          dispatch(getMemberProfileEntitiesSuccess(userId, { notes: res.data }));
        } else {
          console.warn('ERROR: memberProfileActions/getProfileNote', res.message);
        }
        return res;
      });
    }
    return Promise.resolve({ success: true });
  };
}

export function postCreateNote(userId: number, params: any) {
  return (dispatch: any, getState: any) => {
    const memberProfile = getState().memberProfileReducer[userId];
    if (memberProfile) {
      dispatch(
        updateMemberProfileState({
          [userId]: { ...memberProfile, isSuccess: false, message: '' },
        })
      );
    }
    return memberProfileService.postCreateNote(userId, params).then(res => {
      if (res.success) {
        if (memberProfile) {
          let updateState = {
            notificationModal: {
              isShow: true,
              message: res.data && res.data.noteId ? 'MemberProfileScreen.ContentFailUpdateNote' : res.data,
              messageKey:
                res.data && res.data.noteId ? 'MemberProfileScreen.ContentSuccessNote' : 'MemberProfileScreen.ContentFailUpdateNote',
            },
            [userId]: {
              ...memberProfile,
              notes: res.success ? [...memberProfile.notes, res.data] : [...memberProfile.notes],
              isSuccess: res.success,
              message: res.data,
            },
            isShowAddNote: false,
          };
          if (memberProfile.isShowAddNote) {
            updateState = { ...updateState, isShowAddNote: false };
          }
          dispatch(updateMemberProfileState({ ...updateState }));
        }
        dispatch(updateDataSpotlightModalSuccess(userId.toString(), { notes: [res.data] }));
      } else {
        dispatch(updateMessageNotificationError('Error occurred while processing the request'));
      }
      return res;
    });
  };
}

export function patchUpdateNote(userId: number, noteId: number, indexNote: number, params: any) {
  return (dispatch: any, getState: any) => {
    const memberProfile = getState().memberProfileReducer[userId];
    if (memberProfile) {
      dispatch(
        updateMemberProfileState({
          [userId]: { ...memberProfile, isSuccess: false, message: '' },
        })
      );
    }
    return memberProfileService.patchUpdateNote(noteId, params).then(res => {
      if (res.success) {
        let notes = [...(memberProfile?.notes || [])];
        if (params.Note !== '') {
          notes[indexNote] = { ...notes[indexNote], note: params.Note };
        } else {
          notes = [];
        }
        // notes[indexNote] = (res.success && res.data !== null) ? {...res.data} : {...notes[indexNote]};
        if (memberProfile) {
          let updateState = {
            notificationModal: {
              isShow: true,
              message: res.data && res.data.noteId ? 'MemberProfileScreen.ContentFailUpdateNote' : res.data,
              messageKey:
                res.data && res.data.noteId ? 'MemberProfileScreen.ContentSuccessUpdateNote' : 'MemberProfileScreen.ContentFailUpdateNote',
            },
            [userId]: {
              ...memberProfile,
              notes: [...notes],
              isSuccess: res.success,
              message: res.data,
            },
            isShowAddNote: false,
          };
          if (memberProfile.isShowAddNote) {
            updateState = { ...updateState, isShowAddNote: false };
          }
          dispatch(updateMemberProfileState({ ...updateState }));
        }
        dispatch(updateDataSpotlightModalSuccess(userId.toString(), { notes }));
      } else {
        dispatch(updateMessageNotificationError('Error occurred while processing the request'));
      }
      return res;
    });
  };
}

export function postCreateBlockUser(userId: number, callBack = () => {}) {
  return userActions.blockUser(messageUtils.addPrefixAndSuffix(userId), callBack, '', {
    userIdBlocked: userId,
    isPrivateGroup: true,
  });
}

export function postCreateReportUser(userId: number, params: any) {
  return (dispatch: any) => {
    return memberProfileService.postCreateReportUser(userId, params).then(res => {
      if (!res.success) {
        dispatch(updateMessageNotificationError('Error occurred while processing the request'));
      }
      return res;
    });
  };
}

export function postUserMemberProfileAction(user: IMemberProfile, index: number, actionType: string, params: any, callback?: any) {
  return (dispatch: any, getState: any) => {
    const {
      memberProfileReducer,
      commonStateReducer: { dataSpotlightModal },
    } = getState();
    const memberProfile = memberProfileReducer[user.userId || -1];
    let profileIntersectionOld = memberProfile?.profileIntersection;
    let isFavMutual = false;
    let isLikMutual = false;
    if (!profileIntersectionOld) {
      profileIntersectionOld = user.profileIntersection;
    }
    if (profileIntersectionOld && actionType === MEMBER_SEARCH_SCREEN.ACTION_TYPE.LIKE) {
      isFavMutual = profileIntersectionOld.isFavoritedMutual;
      isLikMutual = profileIntersectionOld.isLikedMutual;
    }
    const bodyParams = {
      Id: user.userId,
      Type: params && params.type ? params.type : actionType,
      dataKey: params && params.dataKey,
      fromProfileIndex: params && params.fromProfileIndex,
      isOnlyFavourite: profileIntersectionOld?.isLiked || false,
    };
    dispatch(postUserMemberProfileActionSuccess(user, index, actionType, bodyParams, true, false, false));

    return memberSearchService.postUserMemberSearchAction((user.userId || -1).toString(), index, actionType, bodyParams).then(res => {
      // console.log(res)
      if (res.success) {
        const { LIKE, UNLIKE, FAVORITE, IGNORE } = MEMBER_SEARCH_SCREEN.ACTION_TYPE;
        // update new action for User if out of like/fav then reverse status of User
        if (actionType !== IGNORE) {
          let newActionType = actionType;
          let newActionSuccess = res.actionSuccess;
          let newLikeMutual = (res.data && res.data.isLikedMutualMatch) || false;
          let newFavMutual = (res.data && res.data.isFavouritedMutualMatch) || false;
          // Check out of like/fav
          if (
            res.data &&
            ((res.data.remainingFavourites === 0 && params.type === FAVORITE) || (res.data.remainingLikes === 0 && params.type === LIKE)) &&
            res.data.resultType === STATUS_RESULT_TYPE.SEND_LIMIT
          ) {
            newActionType = UNLIKE;
            newActionSuccess = true;
            newLikeMutual = isLikMutual;
            newFavMutual = isFavMutual;
          }
          if (memberProfile) {
            dispatch(
              postUserMemberProfileActionSuccess(user, index, newActionType, bodyParams, newActionSuccess, newLikeMutual, newFavMutual)
            );
          }

          if (dataSpotlightModal.length > 0) {
            if (newActionSuccess) {
              if (newActionType === LIKE) {
                profileIntersectionOld = {
                  ...profileIntersectionOld,
                  isFavorited: bodyParams.Type === FAVORITE && newActionType === LIKE,
                  isFavoritedMutual: newFavMutual,
                  isLiked: newActionType === LIKE,
                  isLikedMutual: newFavMutual ? newFavMutual : newLikeMutual,
                };
              }
              if (newActionType === UNLIKE) {
                if (bodyParams.Type === FAVORITE) {
                  profileIntersectionOld = {
                    ...profileIntersectionOld,
                    isFavorited: false,
                    isFavoritedMutual: false,
                  };
                  if (!bodyParams.isOnlyFavourite) {
                    profileIntersectionOld = {
                      ...profileIntersectionOld,
                      isLiked: false,
                      isLikedMutual: false,
                    };
                  }
                } else {
                  profileIntersectionOld = {
                    ...profileIntersectionOld,
                    isLiked: false,
                    isLikedMutual: false,
                  };
                }
              }
            }
          }
          dispatch(updateDataSpotlightModalSuccess((user.userId || -1).toString(), { profileIntersection: profileIntersectionOld }));
        } else {
          if (dataSpotlightModal.length > 0) {
            const newData = dataSpotlightModal.filter((itm: any) => itm.detail.userId !== user.detail.userId);
            dispatch(updateCommonStateReducerSuccess({ dataSpotlightModal: newData }));
          }
        }

        // Call back
        if (typeof callback === 'function') {
          callback(res);
        }
        // Update user status
        if (res.data) {
          dispatch(
            updateUserStatusActionSuccess({
              ...res.data,
              type: params && params.type ? params.type : actionType,
            })
          );
        }
      } else {
        if (res.data) {
          dispatch(
            updateUserStatusActionSuccess({
              ...res.data,
              type: params && params.type ? params.type : actionType,
            })
          );
        }
        dispatch(postUserMemberProfileActionSuccess(user, index, MEMBER_SEARCH_SCREEN.ACTION_TYPE.UNLIKE, bodyParams, true, false, false));
        console.warn('ERROR: memberProfileActions/postUserMemberSearchAction', res.message);
      }
      return res;
    });
  };
}

export function updateMemberProfilePropertyStateDispatch(data: any) {
  return (dispatch: any) => {
    dispatch(updateMemberProfilePropertyState(data));
  };
}

export function createProfileView(userId: number) {
  return (dispatch: any) => {
    dispatch(memberProfileService.postCreateProfileView(userId));
  };
}
export function getProfileActivity(userId: number) {
  return (dispatch: any) => {
    return memberProfileService.getProfileActivity(userId).then(res => {
      if (res.success) {
        dispatch(getProfileActivitySuccess(res.data || [], userId));
      } else {
        dispatch(getProfileActivitySuccess([], userId));
      }
      return res;
    });
  };
}

export function toggleUserPhotoLike(userId: number, photoId: number, isLike: boolean) {
  return (dispatch: any, getState: any) => {
    const {
      newFeedReducer: { dataNewFeed, dataPinnedContent },
      memberProfileReducer,
    } = getState();

    const updateLikes = (data: any) => {
      return data.map((item: any) => {
        const { contentItem, userId: itemUserId, typeId } = item;

        if (contentItem?.profilePhotos?.length > 0 && itemUserId === userId && typeId === TYPE.UPLOADED.UserPhotoUploaded) {
          const photoIndex = contentItem.profilePhotos.findIndex((p: any) => p.photoID === photoId);

          if (photoIndex !== -1) {
            const newProfilePhotos = [...contentItem.profilePhotos];
            const currentPhoto = newProfilePhotos[photoIndex];
            const newLikeCount = isLike ? currentPhoto.memberLikeCount + 1 : currentPhoto.memberLikeCount - 1;

            newProfilePhotos[photoIndex] = {
              ...currentPhoto,
              isLiked: isLike,
              memberLikeCount: newLikeCount,
            };

            return {
              ...item,
              contentItem: {
                ...contentItem,
                profilePhotos: newProfilePhotos,
              },
            };
          }
        }
        return item;
      });
    };

    const updatedDataNewFeed = updateLikes(dataNewFeed);
    const updatedDataPinnedContent = updateLikes(dataPinnedContent);

    // update state for member profile
    const newPhoto: any[] = [];
    if (userId && memberProfileReducer[userId] && memberProfileReducer[userId].photos) {
      memberProfileReducer[userId].photos.forEach((item: any) => {
        let photo = { ...item };
        if (photo.photoId === photoId) {
          photo.isLiked = isLike;
          photo.memberLikeCount = isLike ? photo.memberLikeCount + 1 : photo.memberLikeCount - 1;
        }
        newPhoto.push(photo);
      });
      dispatch(updateMemberProfilePropertyState({ dataKey: [userId.toString(), 'photos'], dataValue: newPhoto }));
      // dispatch(updateMemberProfilePropertyState)
    }

    dispatch(mergeDataHome({ dataNewFeed: updatedDataNewFeed, dataPinnedContent: updatedDataPinnedContent }));

    return isLike ? memberProfileService.createUserPhotoLike(photoId) : memberProfileService.deleteUserPhotoLike(photoId);
  };
}

export function getUserProfilePhoto(userId: number) {
  return (dispatch: any) => {
    if (userId && userId !== -1 && userId !== 0) {
      return memberProfileService.getMemberPhotos(userId).then(res => {
        if (res.success) {
          dispatch(getUserProfilePhotoSuccess(res.data));
        } else {
          console.warn('ERROR: memberProfileActions/getUserProfilePhoto', res.message);
        }
        return res;
      });
    }
    return Promise.resolve({ success: true });
  };
}

export function getUserProfileGroups(userId: number, { page, size }: { page: number; size: number }) {
  return (dispatch: any) => {
    if (userId && userId > 0) {
      return memberProfileService.getProfileGroups(userId, { page, size }).then(res => {
        if (res.success) {
          dispatch(getProfileGroupsSuccess(res.data, userId, size, page));
        } else {
          console.warn('ERROR: memberProfileActions/getUserProfileGroups', res.message);
        }
        return res;
      });
    }
    return Promise.resolve({ success: true });
  };
}
